module.exports = __webpack_public_path__ + "img/EditorialAsphaltThumbnail-768.87a20504.jpg";